<form (change)="saveForm()" [formGroup]="loonVroeger">
    <div *ngIf="loonVroegereArbeid.length > 0">
        <div formArrayName="loonVroegereArbeid">
            <div *ngFor="let loon of loonVroegereArbeid.controls; let i = index;"
                 [formGroupName]="i" class="row">

                <div class="col-auto row" formGroupName="loon">
                    <snelstart-ui-text-form-control (change)="saveForm()"
                                                    [label]="i === 0 ? 'Uitkeringsinstantie' : ''"
                                                    class="custom-input-250"
                                                    formControlName="omschrijving"
                                                    id="omschrijving"

                    >
                    </snelstart-ui-text-form-control>
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Bedrag' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedrag"
                                                      id="bedrag"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div *ngIf="this.isDefAangifte" class="col-auto">
                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                      [decimals]="0"
                                                      [label]="i === 0 ? 'Loonheffing' : ''"
                                                      [required]=true
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="loonheffing"
                                                      id="loonheffing"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>

                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Soort uitkering' : ''"
                                                  [options]="optionsLoonsoort"
                                                  class="custom-input-250 col-auto"
                                                  formControlName="loonsoort"
                >
                </snelstart-ui-select-form-control>
                <div class="col-auto">
                    <snelstart-ui-button (click)="verwijderRijLoonVroeger(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         class="delete"
                                         icon="trash"
                                         id="buttonDelete"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="loonVroegereArbeid.length === 0">
    <snelstart-ui-button (click)="addRijLoonVroeger()" class="snelstart-ui-button" icon="plus"
                         type="link">Pensioen/uitkering invullen
    </snelstart-ui-button>
</div>

<div *ngIf="loonVroegereArbeid.length > 0">
    <snelstart-ui-button (click)="addRijLoonVroeger()" class="snelstart-ui-button" icon="plus"
                         type="link">Pensioen/uitkering toevoegen
    </snelstart-ui-button>
</div>

<div *ngIf="heeftLoonsoort11">
    <div class="space20"></div>

    <form (change)="saveForm()" [formGroup]="rechtOpAowAlleenstaande">
        <div class="row mb-1">
            <div class="col-auto pt-1">
                <div *ngIf="!this.partnerBoolean">
                    <p>Heeft {{ this.dataService.naamAangever }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        recht op een AOW-uitkering voor alleenstaanden?</p>
                </div>
                <div *ngIf="this.partnerBoolean">
                    <p>Heeft {{ this.dataService.naamPartner }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        recht op een AOW-uitkering voor alleenstaanden?</p>
                </div>
            </div>
            <div class="col-auto">
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [options]="optionsJaNee"
                                                  class="me-1 custom-input-200"
                                                  formControlName="rechtOpAowAlleenstaande"
                >
                </snelstart-ui-select-form-control>
            </div>
        </div>
    </form>

    @if (aangifte.aangever && aangifte.aangever.burgerlijkeStaat != null &&
    aangifte.aangever.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND &&
    heeftLoonsoort11 &&
    rechtOpAowAlleenstaande.get('rechtOpAowAlleenstaande')?.value === false) {
        <div style="width: 75%" class="pt-2">
            <snelstart-ui-alert type="warning">
                Let op! Er is sprake van een alleenstaande met een AOW-uitkering. Maar de vraag over de alleenstaandeouderenkorting is met NEE
                beantwoord. Is dat juist?
            </snelstart-ui-alert>
        </div>
    }

</div>


<div *ngIf="heeftLoonsoort14">
    <form [formGroup]="krijgtWajong">
        <div class="row mb-1">
            <div class="col-auto pt-4">
                <div *ngIf="!this.partnerBoolean">
                    <p>Heeft {{ this.dataService.naamAangever }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        recht op de jonggehandicaptenkorting (WAJONG)?</p>
                </div>
                <div *ngIf="this.partnerBoolean">
                    <p>Heeft {{ this.dataService.naamPartner }} in {{ incomeTaxEntity.aangifte?.aangifteJaar }}
                        recht op de jonggehandicaptenkorting (WAJONG)?</p>
                </div>
            </div>
            <div class="col-auto">
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [options]="optionsJaNee"
                                                  class="me-1 custom-input-200"
                                                  formControlName="krijgtWajong"
                                                  label="Selecteer"
                >
                </snelstart-ui-select-form-control>
            </div>
        </div>
    </form>
</div>

<div class="space40"></div>

<div *ngIf="this.dubbeleBanenOfUitkeringen() && !this.isDefAangifte" style="width: 75%">
    <snelstart-ui-alert type="info">
        Let op! Bij een verzoek of wijziging voorlopige aanslag wordt de ingehouden loonheffing automatisch
        berekend.<br/>
        Beantwoord hiervoor de volgende vraag 'Meer banen of uitkeringen tegelijk'.
    </snelstart-ui-alert>
</div>
